import {
  AlignJustify,
  ArrowDown,
  ChevronsDown,
  ArrowUp,
  Box,
  Clock,
  Database,
  DownloadCloud,
  Layers,
  Settings,
  Truck,
  XCircle,
  HardDrive,
  Search,
  Edit,
  Repeat,
  Shuffle,
  ChevronsRight,
  CornerUpRight,
  Anchor,
  RefreshCcw,
  Clipboard,
  List,
  Grid,
  Play,
  Layout,
  MapPin,
  Package,
  Smartphone,
  Unlock,
  RotateCw,
  PlusCircle,
  Printer,
  Tag,
} from "react-feather";

export const MENUITEMS = [
  {
    path: "/receivement-menu",
    title: "Recebimento",
    type: "link",
    icon: ChevronsDown,
    active: false,
    children: [
      {
        path: "/suppliers/queue",
        title: "Fila de Fornecedores",
        type: "link",
        icon: Truck,
        active: false,
      },
      {
        path: "/receivement",
        title: "Recebimento",
        type: "link",
        icon: ArrowDown,
        active: false,
      },
      {
        path: "/tax-coupon/entry",
        title: "Cupom fiscal",
        type: "link",
        icon: Tag,
        active: false,
      },
      {
        path: "/pending-receivements",
        title: "Rec. pendentes",
        type: "link",
        icon: CornerUpRight,
        active: false
      },
      {
        path: "/email-settings",
        title: "Configurações",
        type: "link",
        icon: Settings,
        active: false
      }
    ],
  },
  {
    path: "/swap-or-return-menu",
    title: "Troca/Devolução",
    type: "link",
    icon: RotateCw,
    active: false,
    children: [
      {
        path: "/swap-or-return/manage",
        title: "Gerenciar",
        type: "link",
        icon: List,
        active: false,
      },
      {
        path: "/swap-or-return/create",
        title: "Criar",
        type: "link",
        icon: PlusCircle,
        active: false,
      }
    ],
  },
  {
    path: "/fresh/receivement",
    title: "Recebimento Fresh",
    type: "link",
    icon: DownloadCloud,
    active: false,
  },
  {
    path: "/receivement/list",
    title: "Acordos de Recebimento",
    type: "link",
    icon: Database,
    active: false,
  },
  {
    path: "/list/receivement",
    title: "Lista de Recebimento",
    type: "link",
    icon: AlignJustify,
    active: false,
  },
  {
    path: "/fresh/fraction",
    title: "Fracionamento Fresh",
    type: "link",
    icon: Layers,
    active: false,
  },
  {
    path: "/stock/withdraws",
    title: "Saídas",
    type: "link",
    icon: ArrowUp,
    active: false,
  },
  {
    path: "/adjustments",
    title: "Ajustes",
    type: "link",
    icon: Settings,
    active: false,
    children: [
      {
        path: "/adjustments/stock-adjustment",
        title: "Ajuste de Estoque",
        type: "link",
        icon: Edit,
        active: false,
      },
      {
        path: "/adjustments/loss",
        title: "Avarias",
        type: "link",
        icon: XCircle,
        active: false,
      },
      {
        path: "/adjustments/adjustment-in-batch",
        title: "Ajuste por Planilha",
        type: "link",
        icon: Database,
        active: false,
      },
      {
        path: "/adjustments/pending-adjustments",
        title: "Ajustes pendentes",
        type: "link",
        icon: Clock,
        active: false,
      },
    ],
  },
  {
    path: "/transfers-menu",
    title: "Transferências",
    type: "link",
    icon: Truck,
    active: false,
    children: [
      {
        path: "/transfers/generate",
        title: "Gerar",
        type: "link",
        icon: Clipboard,
        active: false,
      },
      {
        path: "/transfers/manage",
        title: "Gerenciar",
        type: "link",
        icon: List,
        active: false,
      },
      {
        path: "/transfers/cages/manage",
        title: "Gerenciar Gaiolas",
        type: "link",
        icon: List,
        active: false,
      },
      {
        path: "/transfers/receive",
        title: "Receber",
        type: "link",
        icon: Shuffle,
        active: false,
      }
    ],
  },
  {
    path: "/restocking",
    title: "Reposição",
    type: "link",
    icon: RefreshCcw,
    active: false,
    children: [
      {
        path: "/restocking/generate",
        title: "Gerar Listas",
        type: "link",
        icon: Clipboard,
        active: false,
      },
      {
        path: "/restocking/manage",
        title: "Gerenciar Listas",
        type: "link",
        icon: List,
        active: false,
      },
      {
        path: "/restocking/webapp/badge",
        title: "App",
        type: "link",
        icon: Smartphone,
        active: false,
      },
      {
        path: "/restocking/divergence",
        title: "Divergências",
        type: "link",
        icon: Shuffle,
        active: false,
      },
      {
        path: "/restocking/label/print",
        title: "Etiquetas",
        type: "link",
        icon: Printer,
        active: false,
      }
    ],
  },
  {
    path: "/inventory",
    title: "Inventário",
    type: "link",
    icon: Grid,
    active: false,
    children: [
      {
        path: "/inventory/list",
        title: "Listar",
        type: "link",
        icon: List,
        active: false,
      },
      {
        path: "/inventory/execute",
        title: "Executar",
        type: "link",
        icon: Play,
        active: false,
      },
    ],
  },
  {
    path: "/stock/movimentations",
    title: "Movimentações Op",
    type: "link",
    icon: Box,
    active: false,
  },
  {
    path: "/stock-managment/",
    title: "Gestão de estoque",
    type: "link",
    icon: HardDrive,
    active: false,
    children: [
      {
        path: "/stock-managment/list",
        title: "Consultar estoque",
        type: "link",
        icon: Search,
        active: false,
      },
      {
        path: "/stock-managment/movements",
        title: "Movimentações",
        type: "link",
        icon: AlignJustify,
        active: false,
      },
      {
        path: "/stock-managment/stock-addressing-in-batch",
        title: "Endereçamento de Estoque por Planilha",
        type: "link",
        icon: Database,
        active: false,
      },
      {
        path: "/stock-managment/update-flv-availability",
        title: "Liberação FLV",
        type: "link",
        icon: Unlock,
        active: false,
      },
    ],
  },
  {
    path: "/movements",
    title: "Movimentação",
    type: "link",
    icon: Repeat,
    active: false,
    children: [
      {
        path: "/movement/batches",
        title: "Mov. de lotes",
        type: "link",
        icon: ChevronsRight,
        active: false,
      },
      {
        path: "/movements/replacement-main",
        title: "Reposição",
        type: "link",
        icon: Shuffle,
        active: false,
      },
    ]
  },
  {
    path: "/basic-queries",
    title: "Consultas Básicas",
    type: "link",
    icon: Search,
    active: false,
  },
  {
    path: "/shed-management",
    title: "Gestão de galpão",
    type: "link",
    icon: Layout,
    active: false,
    children: [
      {
        path: "/shed-management/locations",
        title: "Atributos localizações",
        type: "link",
        icon: MapPin,
        active: false,
      },
      {
        path: "/shed-management/products",
        title: "Atributos produtos",
        type: "link",
        icon: Package,
        active: false,
      },
      {
        path: "/shed-management/add-locations",
        title: "Cadastrar Localizações",
        type: "link",
        icon: Package,
        active: false,
      },
    ],
  },
  {
    path: "/dock-management",
    title: "Gestão de Docas",
    type: "link",
    icon: Anchor,
    active: false,
  },

  {
    path: "/settings",
    title: "Configurações",
    type: "link",
    icon: Settings,
    active: false,
    children: [
      {
        path: "/settings/printers-management",
        title: "Impressoras",
        type: "link",
        icon: Printer,
        active: false,
      },
    ],
  }
];
